<template>
  <div class="calculator" :id="calculatorName">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 col-xl-8 mb-3">
          <div class="progress-container">
                    <div class="progress-bar-bg">
                        <div class="progress-bar-fill" :style="{ width: ((currentStep - 1) / (totalSteps - 1)) * 100 + '%' }"></div>
                    </div>
                </div>

                <div class="step-nav-buttons mt-4 text-center">
                    <button
                        type="button"
                        class="btn previous-step"
                        @click="prevStep"
                        v-if="currentStep != 1"
                    >
                        Back
                    </button>
                </div>

				<div class="calculator-container">

					<div class="mt-3" @keyup="resetCalculation" @change="resetCalculation">

						<div v-if="currentStep === 1">
							<InputElement
								fieldText="What is the current value of your property?"
							>
							<InputTypeNumber currencyPlaceholder v-model="propertyValue"/>
							</InputElement>
						</div>

						<div class="row mb-5" v-if="currentStep === 2">
							<div class="col-12 booleanLabel">Type of home</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="House"
								>
								<input type="radio" v-model="propertyType" value="House">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Flat"
								>
								<input type="radio" v-model="propertyType" value="Flat">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div class="row mb-5" v-if="currentStep === 3">
							<div class="col-12 booleanLabel">Where is your property located?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="North East"
								>
								<input type="radio" v-model="region" value="North East">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="North West"
								>
								<input type="radio" v-model="region" value="North West">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Yorkshire and the Humber"
								>
								<input type="radio" v-model="region" value="Yorkshire and the Humber">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="East Midlands"
								>
								<input type="radio" v-model="region" value="East Midlands">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="West Midlands"
								>
								<input type="radio" v-model="region" value="West Midlands">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="Eastern"
								>
								<input type="radio" v-model="region" value="Eastern">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="South East"
								>
								<input type="radio" v-model="region" value="South East">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="South West"
								>
								<input type="radio" v-model="region" value="South West">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="London"
								>
								<input type="radio" v-model="region" value="London">
								</MultiplyChoiceButton>
							</div>
						</div>

						<BooleanChoiceButtons
							fieldText="Do you live in the district of Watford?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
							v-if="currentStep === 4"
						>
							<template v-slot:left>
								<input type="radio" v-model="watfordResident" value="Yes">
							</template>
							<template v-slot:right>
								<input type="radio" v-model="watfordResident" value="No">
							</template>
						</BooleanChoiceButtons>

						<BooleanChoiceButtons
							fieldText="Do you live in the any of the following: Chiltern, Epsom & Ewell, Hart, Oxford, Reading, Reigate & Banstead, Tonbridge & Malling, Vale of the White Horse and West Berkshire?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
							v-if="currentStep === 5"
						>
							<template v-slot:left>
								<input type="radio" v-model="seResident" value="Yes">
							</template>
							<template v-slot:right>
								<input type="radio" v-model="seResident" value="No">
							</template>
						</BooleanChoiceButtons>

						<BooleanChoiceButtons
							fieldText="Do you live in the boroughs of Barking and Dagenham and Havering?"
							buttonTextLeft="Yes"
							buttonTextRight="No"
							v-if="currentStep === 6"
						>
							<template v-slot:left>
								<input type="radio" v-model="londonResident" value="Yes">
							</template>
							<template v-slot:right>
								<input type="radio" v-model="londonResident" value="No">
							</template>
						</BooleanChoiceButtons>

						<div v-if="currentStep === 7">
							<InputElement
								fieldText="How many years have you been a tenant?"
							>
							<InputTypeNumber v-model="years"/>
							</InputElement>
						</div>

						

						<div class="row mb-5" v-if="currentStep === 8">
							<div class="col-12 booleanLabel">Why are you using the calculator today?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="I’m ready to get a mortgage"
								>
								<input type="radio" v-model="calcReason1" value="I’m ready to get a mortgage">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I’m curious to know what I can borrow"
								>
								<input type="radio" v-model="calcReason1" value="I’m curious to know what I can borrow">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="I want to understand what I can afford before I search for a home"
								>
								<input type="radio" v-model="calcReason1" value="I want to understand what I can afford before I search for a home">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div class="row mb-5" v-if="currentStep === 9">
							<div class="col-12 booleanLabel">When are you hoping to move?</div>
							<div class="col-12 row calc-right-buttons-wrapper">
								<MultiplyChoiceButton
									buttonText="As soon as possible"
								>
								<input type="radio" v-model="calcReason2" value="As soon as possible">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="In the next 3 months"
								>
								<input type="radio" v-model="calcReason2" value="In the next 3 months">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="6-12 months from now"
								>
								<input type="radio" v-model="calcReason2" value="6-12 months from now">
								</MultiplyChoiceButton>
								<MultiplyChoiceButton
									buttonText="12+ months from now"
								>
								<input type="radio" v-model="calcReason2" value="12+ months from now">
								</MultiplyChoiceButton>
							</div>
						</div>

						<div class="step-nav-buttons mt-4 text-center">
							<button
								type="button"
								class="btn next-step"
								@click="nextStep"
								v-if="currentStep != totalSteps - 1 && currentStep != 10"
								:disabled="!isStepValid"
							>
								Continue
							</button>

							<button
								type="button"
								class="btn calculate"
								v-if="currentStep === totalSteps - 1"
								@click="calculate"
								:disabled="!isStepValid"
							>
								Calculate
							</button>
						</div>
						
					</div>	
					
					<div v-if="currentStep === 10" ref="resultsContainer">

						<ResultsContainer class="mt-5 mb-5 calc-results-box">
							<div class="mb-3 results-title" >Discount:</div>
							<span class="fcs-price" >{{calculatedDiscountPerc.toFixed(0)}}%</span>
							<div class="mt-3 results-title" >Giving a discount of</div>
							<span class="fcs-price" >£{{discountAmount}}</span>
							<div class="mb-3 results-title" >Meaning you could buy your home for</div>
              <span class="fcs-price" >£{{purchaseAmount}}</span>
						</ResultsContainer>

						<SubmissionForm :calculatorName="calculatorName" :calculatorData="collateMessageBody"/>

					</div>

				</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanChoiceButtons from '@/components/utilities/booleanChoiceButtons.vue'
import InputElement from '@/components/utilities/inputElement.vue'
import InputTypeNumber from '@/components/utilities/inputTypeNumber.vue'
import ResultsContainer from '@/components/utilities/resultsContainer.vue'
import MultiplyChoiceButton from '@/components/utilities/multiplyChoiceButton.vue'
import SubmissionForm from '@/components/utilities/submissionForm.vue'
import axios from "axios"

export default {
  components: {
    BooleanChoiceButtons,
		InputElement,
		InputTypeNumber,
		ResultsContainer,
		MultiplyChoiceButton,
		SubmissionForm	
  },
  data() {
    return {
      currentStep: 1,
			totalSteps: 10,
      calculatorName: 'right-to-buy-discount-calculator',
      propertyValue: 0,
      propertyType: '',
      region: '',
      londonResident: false,
      watfordResident: false,
      seResident: false,
      years: 0,
      
      minYears: 3,					//minimum years resident in council property
      maxDiscountPerc: 70,				//maximum percentage
      maxDiscount: '', 			//maximum possible discount
      
      //House settings
      houseDiscountPerc: 35,			//house discount start percentage
      housePercIncreasePerYear: 1, 	//discount percentage per additional year from minimum (house)

      //Flat settings
      flatDiscountPerc: 50,			//Flat discount start percentage
      flatPercIncreasePerYear: 2,	    //discount percentage per additional year from minimum (flat)
      calcCompleted: false,

      result: '',
      calculatedDiscountPerc: 0,
      discountAmount: 0,
      purchaseAmount: 0,
      calculatorReasonTitle: null,
      calculatorReasonResults: null,
      calcReason1: "",
      calcReason2: "",
      listName: "",
      emailAddress: "",
      consent: "",
      
      submissionReason: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      submissionList: {
        submitted: false,
        is_valid: false,
        confirmation_message: ''
      },
      formErrors: [],
      gfid: 6, //Please check the Gravity Form for corresponding form id (staging and live may vary!)
      gfidlist: 9 //Please check the Gravity Form for corresponding form id (staging and live may vary!)
    }
  },
  methods: {
    calculate() {
      if (this.currentStep < this.totalSteps) {
				this.currentStep++;
			}
      if( this.years < this.minYears ) {
        this.result = `To be eligible for Right to Buy you must have been a council tenant for a minimum of 3 years.`
      } else {

        if (this.region === 'North East'){
          this.maxDiscount = 22000;
        } else if (this.region === 'North West') {
          this.maxDiscount = 26000;
        } else if (this.region === 'Yorkshire and the Humber') {
          this.maxDiscount = 24000;
        } else if (this.region === 'East Midlands') {
          this.maxDiscount = 24000;
        } else if (this.region === 'West Midlands') {
          this.maxDiscount = 26000;
        } else if (this.region === 'Eastern') {
          if(this.watfordResident === 'Yes') {
            this.maxDiscount = 16000;
          } else {
            this.maxDiscount = 34000;
          }
        } else if (this.region === 'South East') {
          if(this.seResident === 'Yes') {
            this.maxDiscount = 16000;
          } else {
            this.maxDiscount = 38000;
          }
        } else if (this.region === 'South West') {
          this.maxDiscount = 30000;
        } else {
          this.maxDiscount = 16000;
          if(this.londonResident === 'Yes') {
            this.maxDiscount = 38000;
          } else {
            this.maxDiscount = 16000;
          }
        }

        if( this.propertyType === 'House' ) {
          this.calculatedDiscountPerc = this.houseDiscountPerc + ( this.housePercIncreasePerYear * ( this.years - this.minYears ))
        }

        if( this.propertyType === 'Flat' ) {
          this.calculatedDiscountPerc = this.flatDiscountPerc + ( this.flatPercIncreasePerYear * ( this.years - this.minYears ))
        }

        //Check if the calculated discount percentage has not breached the maximum discount percentage
        if( this.calculatedDiscountPerc > this.maxDiscountPerc ) {
          this.calculatedDiscountPerc = this.maxDiscountPerc //update discount to maximum discount percentage
        }

        this.discountAmount = ( this.propertyValue / 100 ) * this.calculatedDiscountPerc

        //Check if the calculated discount has not breached the maximum discount
        if( this.discountAmount > this.maxDiscount ) {
          this.discountAmount = this.maxDiscount //update discount to maximum discount
          //recalculate maximum percentage
          this.calculatedDiscountPerc = ( this.discountAmount / this.propertyValue ) * 100
        }

        this.purchaseAmount = ( this.propertyValue - this.discountAmount )
        this.result =
            `
					<p>Discount: ${this.calculatedDiscountPerc.toFixed(0)}%</p>
					<p>Giving a discount of<br>£${this.discountAmount}</p>
					<p>Meaning you could buy your home for £${this.purchaseAmount}</p>
				`

      }
      this.calcCompleted = true;
      this.calculatorReasonTitle = this.removeHyphensToUpperCase(this.calculatorName);
      this.calculatorReasonResults = 
      `
      Why are you using the calculator today: ${this.calcReason1}
      When will you be ready to move forward: ${this.calcReason2}
      `;
      this.calculatorListName = this.listName;
      this.calculatorEmailAddress = this.emailAddress;
      this.calculatorConsent = this.consent;
      this.$nextTick(() => {
                const resultsContainer = this.$refs.resultsContainer;

                if (resultsContainer) {
                    // Get the bounding rectangle of the element
                    const rect = resultsContainer.getBoundingClientRect();

                    // Calculate the target scroll position
                    const targetScrollPosition = window.scrollY + rect.top - 200;

                    // Scroll to the target position
                    window.scrollTo({
                        top: targetScrollPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('resultsContainer is undefined');
                }
            });
      var newReasonSubmission = new FormData();
      var newListSubmission = new FormData();

      newReasonSubmission.append("form_id", this.gfid); //Please check the Gravity Form form id (staging and live may vary!)
      newReasonSubmission.append("input_1", this.calculatorReasonTitle);
      newReasonSubmission.append("input_3", this.calculatorReasonResults);

      newListSubmission.append("form_id", this.gfidlist); //Please check the Gravity Form form id (staging and live may vary!)
      newListSubmission.append("input_1", this.calculatorListName);
      newListSubmission.append("input_3", this.calculatorEmailAddress);
      newListSubmission.append("input_4.1", this.calculatorConsent ? 1 : 0);

      this.postReasonSubmission(newReasonSubmission);
      this.postListSubmission(newListSubmission);
    },
    async postReasonSubmission(submissionReasonData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/8/submissions', submissionReasonData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionReason = response;
        
        this.submissionReason.is_valid = submissionReason.is_valid;
        this.submissionReason.confirmation_message = submissionReason.confirmation_message;
        this.submissionReason.validation_messages = submissionReason.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    async postListSubmission(submissionListData) {
      try {
        const response = axios.post('/wp-json/gf/v2/forms/9/submissions', submissionListData, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        });
        const submissionList = response;
        
        this.submissionList.is_valid = submissionList.is_valid;
        this.submissionList.confirmation_message = submissionList.confirmation_message;
        this.submissionList.validation_messages = submissionList.validation_messages;

      } catch(error) {
        console.log(error)
      }
    },
    removeHyphensToUpperCase(str) {
      return str.replace(/(-|^)([^-]?)/g, function(_, prep, letter) { return (prep && ' ') + letter.toUpperCase(); });
    },
    resetCalculation() {
      this.calcCompleted = false;
    },
    nextStep() {
            if (this.currentStep === 3 && this.region != 'Eastern' && this.region != 'South East' && this.region != 'London') {
				this.currentStep = 7;
			} else if (this.currentStep === 3 && this.region === 'Eastern') {
                this.currentStep = 4;
			} else if (this.currentStep === 4 && this.region === 'Eastern') {
                this.currentStep = 7;
			} else if (this.currentStep === 3 && this.region === 'South East') {
                this.currentStep = 5;
			} else if (this.currentStep === 5 && this.region === 'South East') {
                this.currentStep = 7;
			} else if (this.currentStep === 3 && this.region === 'London') {
                this.currentStep = 6;
			} else if (this.currentStep === 6 && this.region === 'London') {
                this.currentStep = 7;
			} else if (this.currentStep < this.totalSteps) {
                this.currentStep++;
            }
        },
        prevStep() {
            if (this.currentStep === 7 && this.region != 'Eastern' && this.region != 'South East' && this.region != 'London') {
				this.currentStep = 3;
			} else if (this.currentStep === 4 && this.region === 'Eastern') {
                this.currentStep = 3;
			} else if (this.currentStep === 7 && this.region === 'Eastern') {
                this.currentStep = 4;
			} else if (this.currentStep === 5 && this.region === 'South East') {
                this.currentStep = 3;
			} else if (this.currentStep === 7 && this.region === 'South East') {
                this.currentStep = 5;
			} else if (this.currentStep === 6 && this.region === 'London') {
                this.currentStep = 3;
			} else if (this.currentStep === 7 && this.region === 'London') {
                this.currentStep = 6;
			} else if (this.currentStep === 10) {
                this.currentStep = 9;
			} else if (this.currentStep < this.totalSteps) {
                this.currentStep++;
            }
        },		
  },
  computed: {
    isStepValid() {
            if (this.currentStep === 1) {
                return this.propertyValue != null;
            }
            if (this.currentStep === 2) {
                return this.propertyType === 'House' || this.propertyType === 'Flat';
            }
            if (this.currentStep === 3) {
                return this.region === 'North East' || this.region === 'North West' || this.region === 'Yorkshire and the Humber' || this.region === 'East Midlands' || this.region === 'West Midlands' || this.region === 'Eastern' || this.region === 'South East' || this.region === 'South West' || this.region === 'London';
            }
            if (this.currentStep === 4) {
                return this.watfordResident === 'Yes' || this.watfordResident === 'No';
            }
            if (this.currentStep === 5) {
                return this.seResident === 'Yes' || this.seResident === 'No';
            }
            if (this.currentStep === 6) {
                return this.londonResident === 'Yes' || this.londonResident === 'No';
            }
			if (this.currentStep === 7) {
                return this.years != null;
            }
			if (this.currentStep === 8) {
                return this.calcReason1 != null;
            }
			if (this.currentStep === 9) {
                return this.calcReason2 != null;
            }
            return true;
        },  
    collateMessageBody() {
      let calculatorData = {
        calculatorTitle: this.removeHyphensToUpperCase(this.calculatorName),
        calculatorResults:
            `
					Property Value: £${parseInt(this.propertyValue)}
          Property Type: £${this.propertyType}
					Where is your property located? ${this.region}
					How long you are the tenant? ${this.years} - years

					Discount: ${this.calculatedDiscountPerc.toFixed(0)}%
					Giving a discount of: £${parseInt(this.discountAmount)}
					Meaning you could buy your home for: £${parseInt(this.purchaseAmount)}
          Why are you using the calculator today: ${this.calcReason1}
          When will you be ready to move forward: ${this.calcReason2}
				`
      }

      return calculatorData;
    }
  }
}
</script>

<style lang="scss">
@import './styles/calcs.scss';
</style>